import { render, staticRenderFns } from "./AppCursor.vue?vue&type=template&id=4d072fa6&scoped=true&"
import script from "./AppCursor.vue?vue&type=script&lang=js&"
export * from "./AppCursor.vue?vue&type=script&lang=js&"
import style0 from "./AppCursor.vue?vue&type=style&index=0&id=4d072fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d072fa6",
  null
  
)

export default component.exports